export default __webpack_public_path__ + "static/media/doctor3.183ce366.jpg";